export default __webpack_public_path__ + "static/media/portfolio.f8e70bf3.jpg";